interface IValue {
  clientId?: string
  clientName?: string
  id?: string
  name?: string
}
const safeSetLocalStorage = (key: string, value: IValue) => {
  try {
    // Try to store the full value first
    const stringValue = JSON.stringify(value)
    window.localStorage.setItem(key, stringValue)
  } catch (error) {
    if (error instanceof Error && error.name === 'QuotaExceededError') {
      console.warn(
        `localStorage quota exceeded for key: ${key}. Attempting to store essential data only.`
      )

      try {
        // If quota exceeded, try to store only essential data
        if (key === 'client' && typeof value === 'object') {
          // Store only essential client data
          const essentialClientData = {
            clientId: value.clientId,
            clientName: value.clientName,
            // Add other essential fields as needed
          }
          window.localStorage.setItem(key, JSON.stringify(essentialClientData))
        } else if (key === 'selectedStore' && typeof value === 'object') {
          // Store only essential store data
          const essentialStoreData = {
            id: value.id,
            name: value.name,
            // Add other essential fields as needed
          }
          window.localStorage.setItem(key, JSON.stringify(essentialStoreData))
        } else {
          // For other keys, try to store a minimal version
          const minimalValue =
            typeof value === 'object'
              ? { id: value.id || value.clientId }
              : value
          window.localStorage.setItem(key, JSON.stringify(minimalValue))
        }
      } catch (fallbackError) {
        console.error(
          `Failed to store even minimal data for key: ${key}`,
          fallbackError
        )
        // If even minimal storage fails, clear some old data and try again
        try {
          // Clear some old localStorage items to make space
          const keysToClear = ['oldCache', 'tempData', 'debugData']
          keysToClear.forEach((oldKey) => {
            if (localStorage.getItem(oldKey)) {
              window.localStorage.removeItem(oldKey)
            }
          })

          // Try storing minimal data again
          const minimalValue =
            typeof value === 'object'
              ? { id: value.id || value.clientId }
              : value
          window.localStorage.setItem(key, JSON.stringify(minimalValue))
        } catch (finalError) {
          console.error(
            `Final attempt to store data failed for key: ${key}`,
            finalError
          )
        }
      }
    } else {
      console.error(`Error storing data in localStorage for key: ${key}`, error)
    }
  }
}

export default safeSetLocalStorage
